function load(component) {
    return () =>import (`@/components/${component}.vue`);
};
export default{
    path: "/finance",
    component: load("dashboard"),
    children: [
        {
            path: "",
            name: "client-bill",
            component: load("finance/ClientBill"),
            meta: {
                parent: 'finance',
                child: 'bill',
                deal: false
            }
        },
        {
            path: "create-client",
            name: "create-client-bill",
            component: load("finance/CreateClientBill"),
            meta: {
                parent: 'finance',
                child: 'bill',
                deal: true
            }
        },
        {
            path: "client-bill-info/:id",
            name: "client-bill-info",
            component: load("finance/ClientBillInfo"),
            meta: {
                parent: 'finance',
                child: 'bill',
                deal: false
            }
        },
        {
            path: "supplier-bill",
            name: "supplier-bill",
            component: load("finance/SupplierBill"),
            meta: {
                parent: 'finance',
                child: 'bill',
                deal: false
            }
        },
        {
            path: "create-supplier",
            name: "create-supplier-bill",
            component: load("finance/CreateSupplierBill"),
            meta: {
                parent: 'finance',
                child: 'bill',
                deal: true
            }
        },
        {
            path: "supplier-bill-info/:id",
            name: "supplier-bill-info",
            component: load("finance/SupplierBillInfo"),
            meta: {
                parent: 'finance',
                child: 'bill',
                deal: false
            }
        },
        {
            path: "income",
            name: "income",
            component: load("finance/InCome"),
            meta: {
                parent: 'finance',
                child: 'inout',
                deal: false
            }
        },
        {
            path: "outlay",
            name: "outlay",
            component: load("finance/Outlay"),
            meta: {
                parent: 'finance',
                child: 'inout',
                deal: false
            }
        },
        {
            path: "summary",
            name: "summary",
            component: load("finance/Summary"),
            meta: {
                parent: 'finance',
                child: 'statistics',
                deal: false
            }
        }


    ]

}



// WEBPACK FOOTER //
// ./src/router/finance.js